import { render, staticRenderFns } from "./KgNodeDialog.vue?vue&type=template&id=fbc48e7a"
import script from "./KgNodeDialog.vue?vue&type=script&lang=js"
export * from "./KgNodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports